<template>
  <el-form hide-required-asterisk :model="quickLoginForm" :rules="quickLoginFormRules" ref="quickLoginFormRef" class="login_from">
    <div style="position: relative">
      <el-form-item prop="phone" label="手机号" label-width="100%">
        <el-input placeholder="手机号" v-model.trim="quickLoginForm.phone" clearable></el-input>
      </el-form-item>
      <el-form-item prop="code" class="verification-code" label="验证码" label-width="100%">
        <el-input placeholder="验证码" v-model="quickLoginForm.code" type="text" clearable></el-input>
        <!-- <el-button @click="getVerificationcode" :disabled='true' :class="{'bg-text':btnBool}">{{ yzmtext }}</el-button> -->
        <getCodeBtn ref="getCodeBtn" @click.native="getVerificationcode" />
      </el-form-item>
    </div>
    <div style="height: 22px;padding: 10px 0;"></div>
    <div class="login_btn">
      <el-button @click="quickLogin">登录</el-button>
    </div>
  </el-form>
</template>

<script>
import getCodeBtn from '@/components/getCodeBtn.vue'
import { authenticationMobile } from '@/api/user'

export default {
  components: {
    getCodeBtn
  },
  data () {
    return {
      timer: '',
      btnBool: false,

      yzmtext: '获取验证码',
      quickLoginForm: {
        phone: '',
        code: ''
      },
      quickLoginFormRules: {
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    quickLogin () {
      this.$refs.quickLoginFormRef.validate(vaild => {
        if (!vaild) {
          return false
        } else {
          authenticationMobile({
            mobile: this.quickLoginForm.phone,
            smsCode: this.quickLoginForm.code,
            type: 'ADMIN'
          }).then(res => {
            if (res.data.success) {
              this.$emit('isLogin', res)
            }
          })
        }
      })
    },
    getVerificationcode (e) {
      this.$refs.quickLoginFormRef.validateField('phone', errorMessage => {
        if (errorMessage) return
        this.$refs.getCodeBtn.getCode(this.quickLoginForm.phone, 'LOGIN')
      })
    }
  }

}
</script>

<style lang="less" scoped>
@deep: ~">>>";

/deep/.box {
  width: 138px;
  height: 48px;
  line-height: 48px;
  background: #0052d9;
  border-radius: 6px;

  .login {
    background: #0052d9;
  }

  .login_disabled {
    background: #ced2d8;
  }
}
</style>
